import type { MyProfileEdit } from "@/lib/types";

// 내 명함 수정 폼 상태
export interface ProfileForm {
  biz_name: string;
  biz_position: string;
  biz_cate: string;
  biz_type: string;
  biz_tel: string;
  biz_addr: string;
  biz_addr2: string;
  biz_intro: string;
  biz_url: string;
  hp: string;
  is_biz_show: boolean;
  is_hide_hp: boolean;
  is_hide_birth: boolean;
}

export const EMPTY_FORM: ProfileForm = {
  biz_name: "",
  biz_position: "",
  biz_cate: "",
  biz_type: "",
  biz_tel: "",
  biz_addr: "",
  biz_addr2: "",
  biz_intro: "",
  biz_url: "",
  hp: "",
  is_biz_show: true,
  is_hide_hp: false,
  is_hide_birth: false,
};

export function toForm(edit?: MyProfileEdit): ProfileForm {
  return {
    biz_name: String(edit?.biz_name ?? ""),
    biz_position: String(edit?.biz_position ?? ""),
    biz_cate: String(edit?.biz_cate ?? ""),
    biz_type: String(edit?.biz_type ?? ""),
    biz_tel: String(edit?.biz_tel ?? ""),
    biz_addr: String(edit?.biz_addr ?? ""),
    biz_addr2: String(edit?.biz_addr2 ?? ""),
    biz_intro: String(edit?.biz_intro ?? ""),
    biz_url: String(edit?.biz_url ?? ""),
    hp: String(edit?.hp ?? ""),
    is_biz_show: Number(edit?.is_biz_show ?? 1) === 1,
    is_hide_hp: Number(edit?.is_hide_hp ?? 0) === 1,
    is_hide_birth: Number(edit?.is_hide_birth ?? 0) === 1,
  };
}